import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Tooltip from "@material-ui/core/Tooltip";
import { css } from "emotion";

const columnData = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name"
  },
  { id: "id", numeric: true, disablePadding: true, label: "NCES ID" },
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name"
  },
  { id: "lastName", numeric: false, disablePadding: true, label: "Last Name" },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email Address"
  },
  { id: "user", numeric: false, disablePadding: true, label: "User" },
  { id: "admin", numeric: false, disablePadding: true, label: "Admin" },
  { id: "approver", numeric: false, disablePadding: true, label: "Approver" },
  { id: "uploader", numeric: false, disablePadding: true, label: "Uploader" }
];

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow className={styles.tableHeader}>
          {columnData.map(
            column => (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? "none" : "default"}
                sortDirection={orderBy === column.id ? order : false}
                style={{
                  flexDirection: "row",
                  textAlign: "left",
                  paddingLeft: "20px"
                }}
              >
                {column.label}
              </TableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

export default EnhancedTableHead;

const styles = {
  tableHeader: css`
    background-color: #f5f5f5;
  `
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/components/StaffListTableHead.jsx